import Repository from "./Repository";

const create = '/nhrdn/contactUs/create';

export default {
    create(payload) {
        return Repository.post(create, payload)
    }
}